import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  location: string;
  stars?: number;
  imageUrl?: string;
}
export function TestimonialCard({
  quote,
  author,
  location,
  stars = 5,
  imageUrl
}: TestimonialCardProps) {
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6" data-id="element-269">
      <div className="flex gap-1 mb-4" data-id="element-270">
        {Array.from({
        length: stars
      }).map((_, i) => <StarIcon key={i} className="h-5 w-5 text-amber-400 fill-amber-400" data-id="element-271" />)}
      </div>
      <blockquote className="text-gray-700 mb-6" data-id="element-272">"{quote}"</blockquote>
      <div className="flex items-center" data-id="element-273">
        {imageUrl ? <img src={imageUrl} alt={author} className="w-10 h-10 rounded-full mr-3 object-cover" data-id="element-274" /> : <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center mr-3" data-id="element-275">
            {author.charAt(0)}
          </div>}
        <div data-id="element-276">
          <p className="font-medium text-gray-900" data-id="element-277">{author}</p>
          <p className="text-sm text-gray-600" data-id="element-278">{location}</p>
        </div>
      </div>
    </div>;
}